import { MODALS } from '@/voc/constants/overlays.js';

const state = {
    [MODALS.editLabel]: {
        visible: false,
        rendered: false,
        metadata: {},
    },
    [MODALS.deleteLabel]: {
        visible: false,
        rendered: false,
        metadata: {},
    },
    [MODALS.editCategory]: {
        visible: false,
        rendered: false,
        metadata: {},
    },
    [MODALS.deleteCategory]: {
        visible: false,
        rendered: false,
        metadata: {},
    },
    [MODALS.saveFeedbackView]: {
        visible: false,
        rendered: false,
        metadata: {},
    },
};

const mutations = {
    openModal (state, { modal, metadata }) {
        // If the modal has not been rendered yet,
        // set rendered to true so that it is added to the DOM
        if (!state[modal].rendered) state[modal].rendered = true;
        state[modal].visible = true;

        if (metadata) {
            state[modal].metadata = metadata;
        }
    },
    markModalAsNotVisible (state, { modal }) {
        if (state[modal].visible) {
            state[modal].visible = false;
        }
    },
    clearMetadata (state, { modal }) {
        state[modal].metadata = {};
    },
    closeAllModals (state) {
        Object.keys(state).forEach((modal) => {
            if (state[modal].visible) {
                state[modal].visible = false;
                state[modal].metadata = {};
            }
        });
    },
};

const actions = {
    closeAllModals ({ commit, getters }) {
        if (!getters.isAnyModalOpen) return;
        commit('closeAllModals');
    },
    openModal ({ commit }, { modal, metadata }) {
        commit('openModal', { modal, metadata });
    },
    closeModal ({ commit }, { modal }) {
        commit('markModalAsNotVisible', { modal });
        // Wait for modal animation to finish before removing metadata
        setTimeout(() => {
            commit('clearMetadata', { modal });
        }, 200);
    },
};

const getters = {
    isAnyModalOpen: (state) => Object.values(state).some((modal) => modal.visible),
    isAnyLabelModalOpen: (state) => {
        return (
            state.editLabel.visible ||
            state.deleteLabel.visible ||
            state.editCategory.visible ||
            state.deleteCategory.visible
        );
    },
    getModalMetadata: (state) => (modal) => {
        return state[modal].metadata;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
